import { useStore } from 'state/store'
import Employees from 'views/Employees'
import Loading from 'components/Loading'

const EmployeesContainer = () => {
  const workspaceId = useStore(state => state.workspace.id)
  const organizationId = useStore(state => state.organization.id)

  if (!workspaceId || !organizationId) {
    return <Loading />
  }

  return <Employees organizationId={organizationId} workspaceId={workspaceId} />
}

export default EmployeesContainer
